var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-wrapper",class:{ },style:(_vm.cssVars)},[_c('span',{staticClass:"skeleton flex center-all"},[_vm._v(_vm._s(_vm.placeholder))])])
}
var staticRenderFns = []

export { render, staticRenderFns }